<div class="dialog-header">
  <h1 [ngClass]="data.status" id="dialog-confirm-title">{{ data.title | translate }}</h1>
  <app-icon-button
    *ngIf="!disableClose"
    [isOutline]="false"
    [label]="data.cancelText ? (data.cancelText | translate) : ('GENERIC.CLOSE' | translate) + ' ' + data.title"
    icon="close"
    cdkFocusInitial
    buttonId="close-dialog-button"
    backgroundColor="var(--roller-neutral-95)"
    (action)="dismissDialog()">
  </app-icon-button>
</div>

<mat-dialog-content role="main" id="dialog-confirm-message">
  <div *ngIf="data.message" [innerHtml]="data.message | translate | safeHtml"></div>
</mat-dialog-content>

<footer class="dialog-confirm-actions" [ngClass]="{ 'action-is-mobile': data.isMobile, 'confirm-row': data.isAlert }">
  <button
    appSendAnalytics
    mat-stroked-button
    type="button"
    id="cancel-dialog-button"
    *ngIf="data.isCancelVisible"
    [attr.aria-label]="
      data.cancelText ? (data.cancelText | translate) : ('GENERIC.CANCEL' | translate) + ' ' + data.title
    "
    (click)="onConfirmationSelected(false)"
    title="{{ data.cancelText || 'GENERIC.CANCEL' | translate }}">
    <span>{{ data.cancelText || 'GENERIC.CANCEL' | translate }}</span>
    <span *ngIf="data.isTimerVisible" class="confirm-timer">{{ remainingTimeSec | timeFormat }}</span>
  </button>

  <button
    appSendAnalytics
    mat-stroked-button
    type="button"
    id="confirm-button"
    [attr.aria-label]="data.message"
    title="{{ data.confirmText || 'GENERIC.CONFIRM' | translate }}"
    [ngClass]="data.status"
    (click)="onConfirmationSelected(true)"
    cdkFocusInitial
    [innerHtml]="data.confirmText || 'GENERIC.CONFIRM' | translate | safeHtml"></button>
</footer>
